import { useEffect, useState, useCallback } from 'react'
import BigNumber from 'bignumber.js'
import { Contract } from 'web3-eth-contract'

import { getTokenPerBlock } from '../../sushi/utils'
import { poolMasterContract } from '../../userType/poolMasterContract'
import useYam from './useYam'

const useBlockNum2 = (tokenName?: string) => {
  const [blockNum, setBlockNum] = useState<BigNumber>()
  const yam = useYam()

  const masterContract: Contract = poolMasterContract(yam, tokenName)

  const fetchTokenPerBlock = useCallback(async() => {
    try {
      let num = await getTokenPerBlock(masterContract)
      num = new BigNumber(num)
      // eslint-disable-next-line
      setBlockNum(num)
    } catch (e) {
      console.log(e)
    }
  }, [getTokenPerBlock, masterContract])

  useEffect(() => {
    fetchTokenPerBlock()
  }, [fetchTokenPerBlock])


  return blockNum
}

export default useBlockNum2
